export default __webpack_public_path__ + "static/media/bizDAMz_Logo.7f98ac23.png";